import { useState } from 'react';
import DemoSection from '../DemoSection';
import { UITextarea } from '../WebComponents';

export default function TextareaDemo() {
  const [textareaValue, setTextareaValue] = useState('');

  return (
    <DemoSection title="Textarea 文本域" description="用于输入多行文本">
      <DemoSection.Item title="基础用法">
        <div className="demo-content">
          <UITextarea
            label="留言"
            placeholder="请输入留言内容"
            value={textareaValue}
            rows={4}
            onUiInput={(e: any) => setTextareaValue(e.detail.value)}
          />
        </div>
        <div className="code-block">
          <code>{`<UITextarea
  label="留言"
  placeholder="请输入留言内容"
  value={textareaValue}
  rows={4}
  onUiInput={(e) => setTextareaValue(e.detail.value)}
/>`}</code>
        </div>
      </DemoSection.Item>
    </DemoSection>
  );
}
